export default "__VITE_ASSET__NvSrqJBn__"